import { type VariantProps, cva } from 'class-variance-authority';
import { Button } from '../Button/Button';
import { variants } from './Banner';

const bannerAction = cva('', {
  variants,
  defaultVariants: { intent: 'info' },
});

type BannerActionProps = VariantProps<typeof bannerAction> & {
  text: string;
  callback: () => void;
};

export const BannerAction = ({ text, callback, intent }: BannerActionProps) => {
  return (
    <div className={bannerAction({ intent })}>
      <Button intent="ghost" size="small" onClick={() => callback()}>
        {text}
      </Button>
    </div>
  );
};
